<app-dialog-heading [heading]="'Upload Supporting Document'"></app-dialog-heading>

<div class="dialog-container">
  <mat-dialog-content>
    <form [formGroup]="form">
      <div>
        <app-element-select
          [options]="persons"
          [displayLabel]="'Select Person'"
          [required]="true"
          [emitNameValueDTO]="true"
          (selectionChanged)="onPersonSelected($event)">
        </app-element-select>
      </div>

      <div>
        <app-element-select
          [options]="documentTypes"
          [displayLabel]="'Document Type'"
          [required]="true"
          [emitNameValueDTO]="true"
          (selectionChanged)="onDocumentTypeSelected($event)">
        </app-element-select>
      </div>

      <div class="flex justify-center p-r-10">
        <app-file-upload
          customText="Select File"
          [showCustomText]="true"
          [config]="fileUploadConfig"
          [disabled]="!form.valid"
          [iconName]="'attach_file'"
          [fileNameOverride]="fileNameOverride"
          (onUploadSuccess)="onFileUploadSuccess($event)">
        </app-file-upload>
      </div>

      <div *ngIf="uploadedFile" class="mt2">
        <div class="flex justify-around">
          <span class="mt1">{{uploadedFile.name}}{{uploadedFile.extension}}</span>
          <button mat-icon-button color="primary" (click)="onClickDownloadFile()" matTooltip="Download">
            <mat-icon>download</mat-icon>
          </button>
        </div>
      </div>
    </form>
  </mat-dialog-content>

  <mat-dialog-actions align="center" class="mt2 flex">
    <button mat-raised-button color="warn" (click)="onClickCancel()">Cancel</button>
    <button mat-raised-button color="primary" (click)="onClickSubmit()" [disabled]="!form.valid || !uploadedFile">
      Upload
    </button>
  </mat-dialog-actions>
</div>
